<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user && user.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user?.avatar,
                'bg-green-500': user?.status === 'online',
                'bg-amber-500': user?.status === 'away',
                'bg-red-500': user?.status === 'busy',
                'bg-gray-400': user?.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <!-- En-tête avec le nom de l'utilisateur et email -->
    <div class="px-4 py-2">
        <div class="flex items-center">
            <mat-icon>account_circle</mat-icon>
            <div class="ml-2">
                <span class="font-medium text-lg">{{ user?.name || user?.fullName }}</span>
                <br />
                <span class="text-sm">{{ user?.email }}</span>
            </div>
        </div>
    </div>

    <mat-divider></mat-divider>


    <!-- Lien vers le compte -->
    <button mat-menu-item>
        <mat-icon>open_in_new</mat-icon>
        <span>Mon compte</span>
    </button>

    <mat-divider></mat-divider>
    <span class="section-title" style="font-size: 1.1em;
    font-weight: bold;
    margin-left: 10px;
  ">MOSOFTY</span>
    <!-- Options du menu -->
    <button mat-menu-item>
        <mat-icon>person</mat-icon>
        <span>Ma fiche</span>
    </button>
    <button mat-menu-item (click)="navigateToConfiguration()">
        <mat-icon>settings</mat-icon>
        <span>Configuration</span>
    </button>
    <button mat-menu-item (click)="navigateToFlags()">
        <mat-icon>flag</mat-icon>
        <span>Mes flags</span>
    </button>
    <button mat-menu-item>
        <mat-icon>subscriptions</mat-icon>
        <span>Abonnement</span>
    </button>
    <button mat-menu-item>
        <mat-icon>cloud_download</mat-icon>
        <span>Centre de téléchargement</span>
    </button>
    <button mat-menu-item>
        <mat-icon>history</mat-icon>
        <span>Journal d'activité</span>
    </button>
    <button *hasPermission="'ADMIN:MANAGE'" mat-menu-item (click)="navigateToAdministration()">
        <mat-icon>admin_panel_settings</mat-icon>
        <span>Administration</span>
    </button>

    <mat-divider></mat-divider>

    <!-- Déconnexion -->
    <button mat-menu-item (click)="signOut()">
        <mat-icon class="text-red-600">logout</mat-icon>
        <span class="text-red-600">Déconnexion</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>En ligne</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Absent</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Occupé</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
